module.exports = __webpack_public_path__ + "static/img/icon_epay.63898923.png";